import React from 'react';
import {
  Col, Layout, Row, Space,
} from 'antd';
import { FormattedMessage } from 'react-intl';

import { env } from 'config';
import { isRu } from 'services/region/region';

import './AccountFooter.less';

function getPrivacyPolicyUrl(): string {
  return env.REACT_APP_JMIX_PRIVACY_POLICY_URL || 'https://www.jmix.ru/privacy-policy/';
}

function getDataConsentUrl(): string {
  return env.REACT_APP_JMIX_DATA_CONSENT_URL || 'https://www.jmix.ru/data-consent/';
}

export function AccountFooter() {
  const ru = isRu();

  return (
    <Layout.Footer className="account-footer">
      <Layout className="account-footer__container">
        <Row gutter={[16, 16]}>
          <Col flex="0 2 300px">
            <Space>
              <span><FormattedMessage id="jmix-account.footer.developed-by" /></span>
              <a
                target="_blank"
                href={ru ? 'https://www.haulmont.ru/' : 'https://www.haulmont.com/'}
                rel="noreferrer"
              >
                Haulmont
            </a>
            </Space>
          </Col>
          {ru ? (
            <>
              <Col flex="1 0 150px">
                <a href={getPrivacyPolicyUrl()} target="_blank" rel="noreferrer">
                  <FormattedMessage id="jmix-account.footer.privacy-policy" />
                </a>
              </Col>
              <Col flex="1 0 150px">
                <a href={getDataConsentUrl()} target="_blank" rel="noreferrer">
                  <FormattedMessage id="jmix-account.footer.data-consent" />
                </a>
              </Col>
            </>
          ) : (
            <Col flex="1 0 150px">
              <a href="https://www.jmix.io/terms-of-use/">
                <FormattedMessage id="jmix-account.footer.terms-of-use" />
              </a>
            </Col>
          )}
          {/* Links to foreign social networks are not shown on the ru instance (RKN) */}
          {!ru && (
            <Col flex="0 6 200px">
              <Space align="end">
                <ul className="social footer_social">
                  <a
                    href="https://github.com/Haulmont/jmix-core"
                    target="_blank"
                    className="social_link"
                    rel="noreferrer"
                  >
                    <li className="social_item git" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/10601072/"
                    target="_blank"
                    className="social_link"
                    rel="noreferrer"
                  >
                    <li className="social_item ln" />
                  </a>
                  <a
                    href="https://www.facebook.com/JmixFramework"
                    target="_blank"
                    className="social_link"
                    rel="noreferrer"
                  >
                    <li className="social_item fb" />
                  </a>
                  <a
                    href="https://twitter.com/Jmix_framework"
                    target="_blank"
                    className="social_link"
                    rel="noreferrer"
                  >
                    <li className="social_item tw" />
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCEmWc8OwhgHnAV7vVVxtglQ"
                    target="_blank"
                    className="social_link"
                    rel="noreferrer"
                  >
                    <li className="social_item yt" />
                  </a>
                </ul>
              </Space>
            </Col>
          )}
        </Row>
      </Layout>
    </Layout.Footer>
  );
}
